/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermDto } from '../../models/term-dto';

export interface StorageControllerGetTerms$Params {
  key: string;
}

export function storageControllerGetTerms(http: HttpClient, rootUrl: string, params: StorageControllerGetTerms$Params, context?: HttpContext): Observable<StrictHttpResponse<TermDto>> {
  const rb = new RequestBuilder(rootUrl, storageControllerGetTerms.PATH, 'get');
  if (params) {
    rb.query('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TermDto>;
    })
  );
}

storageControllerGetTerms.PATH = '/api/storage/term';
